/**
 * @generated SignedSource<<807ed58fd71c19525c21263c174beb75>>
 * @relayHash 4729d550c381999f4854c5f9588ec703
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID manual

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SmartSpaceOverviewSummaryQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type SmartSpaceOverviewSummaryQuery$data = {
  readonly confluence_smartSpaceOverview: {
    readonly summary: {
      readonly body: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SmartSpaceOverviewSummaryQuery = {
  response: SmartSpaceOverviewSummaryQuery$data;
  variables: SmartSpaceOverviewSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ConfluenceSmartSpaceOverview",
    "kind": "LinkedField",
    "name": "confluence_smartSpaceOverview",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSmartSpaceOverviewSummary",
        "kind": "LinkedField",
        "name": "summary",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "body"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SmartSpaceOverviewSummaryQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SmartSpaceOverviewSummaryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4729d550c381999f4854c5f9588ec703",
    "id": "manual",
    "metadata": {},
    "name": "SmartSpaceOverviewSummaryQuery",
    "operationKind": "query",
    "text": "query SmartSpaceOverviewSummaryQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body}}}"
  }
};
})();

(node as any).hash = "7a74763ab21bd639f041226af8045e27";

export default node;
